import type { DayIndex } from '@solinkcorp/api-types';

export const DAY_INDICES: DayIndex[] = ['0', '1', '2', '3', '4', '5', '6'];
/** TODO(): followup with Shiva on UX message for condition */
export const NO_RANGE_FOR_DAY = 'No time scheduled for this day';
